import { useClientPortalAPI } from "@certn/api";
import { useEffect, useState } from "react";

const useCustomerGroups = () => {
  const { data: customerGroups = [] } = useClientPortalAPI(
    `/api/internal/client-portal/customer-accounts/customer-groups/`
  );
  const [selectedGroup, setSelectedGroup] = useState<string | null>(null);

  useEffect(() => {
    if (!selectedGroup && customerGroups.length > 0) {
      setSelectedGroup(customerGroups[0].name);
    }
  }, [customerGroups, selectedGroup]);

  return { selectedGroup };
};

export default useCustomerGroups;
